module.exports = __webpack_public_path__ + "img/BOARD.24c87231.svg";